document.addEventListener('click',event=>{
 const thumb=event.target.closest('[data-tf-image]');
 if(thumb){event.preventDefault();const gallery=thumb.closest('.tf-gallery');const main=gallery.querySelector('#tf-main-photo');main.src=thumb.dataset.tfImage;main.removeAttribute('srcset');gallery.querySelectorAll('[data-tf-image]').forEach(a=>a.removeAttribute('aria-current'));thumb.setAttribute('aria-current','true');}
 const choose=event.target.closest('[data-tf-choose]');
 if(choose){const form=choose.closest('[data-tf-product]').querySelector('.tf-buy-form');form.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});const selected=form.querySelector('input[name="id"]:checked');if(selected){form.querySelector('button[name="add"]').focus({preventScroll:true});}else{form.querySelector('input[name="id"]:not(:disabled)')?.focus({preventScroll:true});}}
});
document.addEventListener('change',event=>{
 if(event.target.matches('.tf-variants input')){const scope=event.target.closest('[data-tf-product]');const price=scope.querySelector('[data-tf-price]');price.textContent=event.target.dataset.price;const url=new URL(location.href);url.searchParams.set('variant',event.target.value);history.replaceState({},'',url);}
});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.tf-mobile-menu[open]').forEach(el=>el.removeAttribute('open'));}});

document.addEventListener('shopify:block:select', event => {
 const detail = event.target.closest('details');
 if (detail) detail.open = true;
});

if (!customElements.get('tf-announcement-slider')) {
  customElements.define('tf-announcement-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-tf-slide]'));
      this.toggle = this.querySelector('[data-tf-pause]');
      this.current = 0;
      this.paused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.render = () => {
        const reduced = this.motion.matches;
        this.toggleAttribute('data-ready', !reduced);
        this.toggle.hidden = reduced;
        this.slides.forEach((slide, index) => {
          slide.toggleAttribute('data-active', index === this.current);
          if (reduced) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', String(index !== this.current));
        });
      };
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.querySelector('span').textContent = this.paused ? '▶' : 'Ⅱ';
      }, options);
      this.motion.addEventListener('change', this.render, options);
      this.render();
      this.timer = setInterval(() => {
        if (!this.paused && !this.motion.matches && !document.hidden && !this.matches(':hover, :focus-within')) {
          this.current = (this.current + 1) % this.slides.length;
          this.render();
        }
      }, Number(this.dataset.interval) || 6000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller.abort();
    }
  });
}
